import { CSSProperties } from "react"

export const PencilIcon = ({style}: {style?:CSSProperties}) => {
  return <svg viewBox='0 0 64 64' style={style}>
    <g id='surface1'>
    <path
        style={{
          fill:'rgb(80%,80%,80%)',
          stroke:'none',
          fillOpacity:1
        }}
        d="M 6.4145792,43.619857 47.395348,1.0111806 62.567084,15.266548 18.885062,56.816637 4.4895709,60.062974 Z"/>
      <path
        style={{
          stroke:'none',
          fillRule:'nonzero',
          fill:'rgb(0%,0%,0%)',
          fillOpacity:1
        }}
        d='M 62.152344 11.050781 L 52.949219 1.847656 C 50.484375 -0.613281 46.492188 -0.617188 44.027344 1.847656 L 38.058594 7.8125 L 8.902344 36.976562 C 7.695312 38.183594 6.769531 39.644531 6.191406 41.25 L 0.28125 57.699219 C -0.335938 59.417969 0.09375 61.332031 1.382812 62.621094 C 2.671875 63.910156 4.589844 64.339844 6.304688 63.722656 L 22.75 57.8125 C 24.359375 57.230469 25.820312 56.308594 27.027344 55.097656 L 54.625 27.496094 L 54.628906 27.5 L 56.1875 25.9375 L 62.15625 19.96875 C 64.609375 17.503906 64.617188 13.515625 62.152344 11.050781 Z M 21.257812 53.65625 L 10.78125 57.425781 L 6.578125 53.222656 L 10.34375 42.746094 C 10.371094 42.667969 10.410156 42.59375 10.4375 42.519531 L 21.480469 53.5625 C 21.40625 53.59375 21.335938 53.628906 21.257812 53.65625 Z M 23.90625 51.980469 C 23.757812 52.128906 23.597656 52.265625 23.4375 52.398438 L 11.601562 40.566406 C 11.738281 40.40625 11.875 40.246094 12.023438 40.097656 L 40.960938 11.152344 L 52.84375 23.039062 Z M 59.03125 16.851562 L 54.40625 21.476562 L 42.519531 9.59375 L 47.144531 4.96875 C 47.886719 4.230469 49.085938 4.230469 49.828125 4.96875 L 59.03125 14.171875 C 59.769531 14.910156 59.773438 16.105469 59.027344 16.855469 Z M 59.03125 16.851562' />
    </g>
</svg>
}